import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import MenuSection from 'client/components/menu-section';

import './index.css';

import IframeXDM from 'client/components/iframeXDM';

import { PageName } from 'client/bundles/types';

const b = cn('stocks');
const bPageTitle = cn('page-title');

interface Props {
    sectionTitle: string;
    title: string;
    pageName: PageName;
    stocksUrl: string;
}

class Stocks extends Component<Props> {
    static contextType = LangContext;

    render() {
        const { sectionTitle, pageName, stocksUrl, title } = this.props;
        const { lang } = this.context;
        const isLangRu = lang === 'ru';

        let titlePage = sectionTitle;

        if (isLangRu) {
            titlePage = title;
        }

        return (
            <div className={b()}>
                <h1 className={bPageTitle(isLangRu ? { type: 'border' } : '')}>{titlePage}</h1>

                {

                    /* TODO разобраться с подменю IR-571 */
                    lang === 'en' && <MenuSection type="shareholders" pageName={pageName} />
                }

                <IframeXDM url={stocksUrl} />
            </div>
        );
    }
}

export default Stocks;
